import React, { FC } from 'react';
import { Box, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { EquipmentSearchSummary } from '../../services/equipments.service';

export interface EquipmentResultStatsBarProps {
  summary: EquipmentSearchSummary;
  loading?: boolean;
}

function ChipStat({ n, label, primary = false }: { n: number; label: string; primary?: boolean }) {
  return (
    <Chip
      size="small"
      label={
        <>
          <Box component="span" sx={{ fontWeight: 700, color: primary ? 'primary.main' : 'text.primary' }}>
            {n}
          </Box>{' '}
          {label}
        </>
      }
      sx={{
        height: 22,
        bgcolor: primary ? (t) => alpha(t.palette.primary.main, 0.12) : 'grey.100',
        fontWeight: 400,
        fontSize: '0.6875rem',
        color: primary ? 'primary.main' : 'text.secondary',
        borderRadius: 0.75,
        '& .MuiChip-label': { px: 0.75, py: 0 },
      }}
    />
  );
}

const EquipmentResultStatsBar: FC<EquipmentResultStatsBarProps> = ({ summary, loading = false }) => {
  const { total_equipment, count_owned, count_managed, count_skis, count_shoes, count_other, athlete_count } = summary;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 0.75,
        rowGap: 0.5,
        px: 1,
        py: 0.25,
        mb: 0.75,
        minHeight: 32,
        borderRadius: 0.75,
        visibility: loading ? 'hidden' : 'visible',
      }}
    >
      <ChipStat n={total_equipment} label="Total Equipment" primary />
      <ChipStat n={count_owned} label="Owned" />
      <ChipStat n={count_managed} label="Managed" />
      <ChipStat n={count_skis} label="XC Skis" />
      <ChipStat n={count_shoes} label="Shoes" />
      <ChipStat n={count_other} label="Other" />
      <ChipStat n={athlete_count} label="Athletes" />
    </Box>
  );
};

export default EquipmentResultStatsBar;
